exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-form[data-v-18cce924]{padding:30px}.login-message[data-v-18cce924]{font-weight:600;font-size:12px;line-height:16px;margin-bottom:5px;min-height:16px}.login-message--success[data-v-18cce924]{color:#1ab394}.login-message--error[data-v-18cce924]{color:#eb394b}.dev-message[data-v-18cce924]{margin-top:30px;color:#1ab394;font-size:12px}.title[data-v-18cce924]{font-weight:700;font-size:36px;line-height:35px;margin-bottom:5px}.icrs-login-button[data-v-18cce924]{height:50px}.icrs-login-button[data-v-18cce924] span{font-size:20px}.password-row[data-v-18cce924]{margin-top:5px}.sign-in-button[data-v-18cce924]{margin-top:25px}", ""]);

// exports
